export const dateTimeFormat = 'MMM D YY h:mma'
export const dateFormat = 'MMM D YY'



// WEBPACK FOOTER //
// ./src/lib/config.js